module.exports = "<div class=\"frame-component\">\r\n    <iframe id=\"iframe\" width=\"100%\" [src]=\"safeUrl\"  frameborder=\"0\"></iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/frame/frame.component.html
// module id = ../../../../../src/app/core/components/frame/frame.component.html
// module chunks = main